import { A11yModule } from "@angular/cdk/a11y";
import { PortalModule } from "@angular/cdk/portal";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import { TranslateModule } from "@ngx-translate/core";

import { SvgIconComponent } from "@hermes/aphrodite-svg";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic-directives-sr-only-no-snippet";

import { CategoryInstitutionalComponent } from "./components/category-institutional/category-institutional.component";
import { TrayContainerComponent } from "./components/tray-container/tray-container.component";
import { TrayContentComponent } from "./components/tray-content/tray-content.component";
import { TrayOverlayComponent } from "./components/tray-overlay/tray-overlay.component";
import { TrayTitleComponent } from "./components/tray-title/tray-title.component";
import { TrayOpenerDirective } from "./directives/tray-opener.directive";
import { TrayZoneDirective } from "./directives/tray-zone.directive";
import { TrayEffects } from "./effects/tray.effects";
import { reducer, trayFeatureKey } from "./reducers/tray.reducer";

@NgModule({
    imports: [
        A11yModule,
        CommonModule,
        EffectsModule.forFeature([TrayEffects]),
        PortalModule,
        StoreModule.forFeature(trayFeatureKey, reducer),
        SvgIconComponent,
        ReactiveFormsModule,
        TranslateModule,
        SrOnlyNoSnippetDirective,
        CategoryInstitutionalComponent,
        TrayContainerComponent,
        TrayContentComponent,
        TrayTitleComponent,
        TrayOverlayComponent,
        TrayOpenerDirective,
        TrayZoneDirective,
    ],
    exports: [TrayOpenerDirective, TrayZoneDirective, TrayContainerComponent],
})
export class TrayStateModule {}
